import { api } from "./api";

export interface CustomizationAsset {
  _id: string;
  storeId: string;
  name: string;
  type: "background" | "shape";
  url: string;
  originalUrl?: string; // Original unwatermarked version (for backgrounds, admin only)
  watermarkedUrl?: string; // Watermarked URL (for admins, to allow matching watermarked URLs from customizations)
  thumbnailUrl?: string; // Low-resolution thumbnail URL for preview/properties panel
  category?: string;
  fileType: "png" | "svg" | "jpg" | "jpeg" | "webp";
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateAssetRequest {
  name: string;
  type: "background" | "shape";
  url: string;
  category?: string;
  fileType: "png" | "svg" | "jpg" | "jpeg" | "webp";
}

export interface UploadAssetRequest {
  file: File;
  type: "background" | "shape";
  name?: string;
  category?: string;
}

export const customizationAssetApi = {
  async getAssets(type?: "background" | "shape"): Promise<CustomizationAsset[]> {
    const params = type ? `?type=${type}` : "";
    const response = await api.get(`/customization-assets${params}`);
    return response.data;
  },

  async getAsset(id: string): Promise<CustomizationAsset> {
    const response = await api.get(`/customization-assets/${id}`);
    return response.data;
  },

  async createAsset(data: CreateAssetRequest): Promise<CustomizationAsset> {
    const response = await api.post("/customization-assets", data);
    return response.data;
  },

  async uploadAsset(data: UploadAssetRequest): Promise<CustomizationAsset> {
    const formData = new FormData();
    formData.append("file", data.file);
    formData.append("type", data.type);
    if (data.name) formData.append("name", data.name);
    if (data.category) formData.append("category", data.category);

    const response = await api.post("/customization-assets/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },

  async updateAsset(id: string, data: Partial<CustomizationAsset>): Promise<CustomizationAsset> {
    const response = await api.put(`/customization-assets/${id}`, data);
    return response.data;
  },

  async deleteAsset(id: string): Promise<void> {
    await api.delete(`/customization-assets/${id}`);
  },
};

